import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const ABILITATION_REQUEST_URLS: generalConst = {
  BASE_URL: ROUTES.ABILITATIONREQUEST,
  USER_CHOICE: `${ROUTES.ABILITATIONREQUEST}/SecondStep`,
  ABILITATION_CHOICE: `${ROUTES.ABILITATIONREQUEST}/ThirdStep`,
  ABILITATION_SUMMARY: `${ROUTES.ABILITATIONREQUEST}/FourthStep`,
};

export const ABILITATION_MANAGEMENT_FORM_FILTER =
  "AbilitationManagementFormFilter";
export interface IAbilitationManagementProps {
  resetState: () => {};
}

export const STATE_IDENTIFIER = {
  SELECTED_OFFICE: "selectedOffice",
  IS_SELF_SELECTED: "isSelfSelected",
  SELECTED_USER: "selectedUsers",
  ADDED_ENTITLEMENTS: "addedEntitlements",
  ADDED_BR: "addedBR",
  DELETED_ENTITLEMENTS: "deletedEntitlements",
  DELETED_BR: "deletedBR",
  MODIFIED_ENTITLEMENTS: "modifiedEntitlements",
  MODIFIED_BR: "modifiedBR",
  STEP_ONE: "stepOne",
  OFFICES: "offices",
  STEP_TWO: "stepTwo",
  USER: "user",
  PAGINATED_USERS: "paginatedUsers",
  STEP_THREE: "stepThree",
  PREV_ENTITLEMENTS: "prevEntitlements",
  ENTITLEMENTS: "entitlements",
  BUSINESS_ROLES: "businessRoles",
  PAGINATED_ENTITLEMENTS: "paginatedEntitlementsRawData",
  PAGINATED_BUSINESS_ROLES: "paginatedBusinessRoleRawData",
  TOTAL_ENTITLEMENTS: "totalEntitlements",
  STEP_FOUR: "stepFour",
  DELEGATOR: "delegator",
  COMMENT: "comment",
  CALL_STATE: "callState",
  ENTITLEMENTS_BR_SELECTED: "entitlementsBRSelected",
  EXISTING_SAME_DB: "existingSameDB",
  ATTACHMENTS: "attachments",
  IS_COMMENT_COMPULSORY: "isCommentCompulsory",
  SOD_CONFLICTS: "sodConflicts",
  LIST_FULL: "listFull",
  START_END_DATE: "startEndDate",
  SOD_COMMENT:    'sodComment',
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
export const BUSINESS_ROLES_IDENTIFIER: string = "businessRoles";
export const ENTITLEMENTS_IDENTIFIER: string = "entitlements";
export const SHOW_TABLE_IDENTIFIER: string = "showTable";
